export default {"src":"/_next/static/media/mein-schiff.166e0133.svg","height":60,"width":300,"blurWidth":0,"blurHeight":0};